var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",style:({ width: _vm.width, height: _vm.height })},[(_vm.errorMsg)?_c('div',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_c('div',{ref:"mapContainer",staticClass:"map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }